import { SMSMassCommunicationForm } from "../SMSMassCommunicationForm";

export interface AddSMSMassCommunicationProps {}

export const AddSMSMassCommunication = () => {
  return <SMSMassCommunicationForm />;
};
